import { styled } from '../_common/stitches/stitches.config.js';
const StyledImageConstructor = (objectFit, objectPosition) => styled('img', {
  objectFit,
  objectPosition
});
const StyledPicture = styled('picture', {
  display: 'inline-flex'
});
export { StyledImageConstructor, StyledPicture };